import { BaseApi } from './base.api.js';

export class IdentityProviderApi extends BaseApi {
    constructor(client, basePath = '/identity-providers') {
        super(client, basePath);
    }

    async list() {
        const response = await this.client.get(this.basePath);
        return response.data;
    }

    async create(data) {
        const response = await this.client.post(this.basePath, data);
        return response.data;
    }

    async update(id, data) {
        const response = await this.client.put(`${this.basePath}/${id}`, data);
        return response.data;
    }

    async remove(id) {
        const response = await this.client.delete(`${this.basePath}/${id}`);
        return response.data;
    }

    async rotateApiKey(id) {
        const response = await this.client.post(`${this.basePath}/${id}/rotate-api-key`);
        return response.data;
    }

    async testOidc(id) {
        const response = await this.client.post(`${this.basePath}/${id}/test`);
        return response.data;
    }
}
